<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    persistent
    max-width="500"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <span>{{ $t('Order.DepositApproval') }}</span>
        <v-spacer />
        <v-btn icon small @click="onDismiss">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p class="body-1">{{ message || $t('NoData') }}</p>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="onApply">{{ $t('Order.Apply') }}</v-btn>
        <v-btn text @click="onCancel">{{ $t('Order.Cancel') }}</v-btn>
        <v-spacer />
        <v-btn text @click="onDismiss">{{ $t('Close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ApplyDepositModal',
  props: {
    value: { type: Boolean, default: false },
    orderId: { type: [Number, String], default: null },
    message: { type: String, default: '' }
  },
  methods: {
    onApply() {
      this.$emit('apply');
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDismiss() {
      this.$emit('dismiss');
    }
  }
};
</script>

<style scoped></style>
